// extracted by mini-css-extract-plugin
export default {"demo-display":"_7tRks","demoDisplay":"_7tRks","disabled":"basBH"};